import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        {/* Main Content */}
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-12">
          {/* Mission Statement */}
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-light text-white mb-4">Our Mission</h3>
            <p className="text-gray-300 leading-relaxed">
              Our preparatory program is committed to cultivating leadership, excellence, and acceleration in student-athletes. We ensure that 100% of our students graduate from high school fully prepared for their postsecondary and extracurricular aspirations. Our goal is to instill a disciplined sense of citizenship by maximizing their potential.
            </p>
          </div>

          {/* School Services */}
          <div>
            <h4 className="text-lg font-medium text-white mb-4">Learning Comes 1st</h4>
            <ul className="space-y-2 text-gray-300">
              <li>
                <a 
                  href="https://www.secondstep.org/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Second Step (Research-based)
                </a>
              </li>
              <li>
                <a
                  href="/nil-u"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  NIL U
                </a>
              </li>
              <li>
                <a 
                  href="mailto:sonom.advantage@gmail.com"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Products & Services */}
          <div>
            <h4 className="text-lg font-medium text-white mb-4">Products & Services</h4>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://help.uber.com/riders/article/uber-for-teens?nodeId=85c399ab-b302-4cbe-a97b-8196e2f4e5fc" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Transportation (Uber for Teens)
                </a>
              </li>
              <li>
                <a 
                  href="https://www.factor75.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Nutrition (Factor)
                </a>
              </li>
              <li>
                <a 
                  href="/research-2026" 
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  View the R&D Proposal
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 my-8"></div>

        {/* Bottom Section */}
        <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
          {/* Logo */}
          <div className="flex items-center">
            <span className="text-2xl font-light text-white tracking-tight">
              Sonom Performance Institute
            </span>
          </div>
          
          {/* Contact Info */}
          <div className="text-center lg:text-right">
            <div className="text-gray-300 space-y-1">
              <p>Lancaster, PA</p>
              <p>
                <a 
                  href="mailto:sonom.advantage@gmail.com" 
                  className="hover:text-white transition-colors"
                >
                  sonom.advantage@gmail.com
                </a>
              </p>
              <p>
                <a 
                  href="tel:717-577-4120" 
                  className="hover:text-white transition-colors"
                >
                  717-577-4120
                </a>
              </p>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="text-center mt-8">
          <p className="text-sm text-gray-400 font-light">
            © 2025 Sonom Performance Institute, LLC
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;